import client from './api-client';

export const getConfiguracionForm = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getConfiguracionFormImplicado = async(query) => {
    try {
        
        const response = await client.getImplicado(`cfg-forms?q=${query}`); 
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form_implicado: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getConfiguracionForm8 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form8: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getConfiguracionForm9 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form9: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getAntecedentes = async(query) => {
    try {
        
        const response = await client.get(`caso?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                antecedentesCasos: response.data.object,
               
                query: query
            };
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const getLiquidacionPerdida = async(query) => {
    try {
        
        const response = await client.get(`caso/liquidacion?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                liquidacionPerdida: response.data.object,
               
                query: query
            };
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDocumentacion = async(query) => {
    try {
        
        const response = await client.get(`caso/documentos?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                documentacion: response.data.object,
               
                query: query
            };
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getRequisitos = async(query) => {
    try {
        
        const response = await client.get(`requisitos-gestion?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                requisitos: response.data.object,
               
                query: query
            };
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}


export const getSelectDocumentacion= async(query) => {
    try {
        
        const response = await client.getSelect(`caso/implicado/terceros?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                selectDocumentacion: response.data.object,               
                query: query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getCasoImplicado= async(query) => {
    try {
        
        const response = await client.getSelect(`caso/implicado?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                casoImplicado: response.data.object,               
                query: query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getAntecendentesLiquidacion= async(query) => {
    try {
        
        const response = await client.getSelect(`caso/liquidacion?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                antecendentesLiquidacion: response.data.object,               
                query: query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getMarcas= async(query) => {
    try {
        
        const response = await client.getSelect(`marcas?q=${query}`);        
        if (response.status === 200 && response.data.code === 1) {
            return {
                marcas: response.data.object,               
                query: query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getTipoVehiculos= async(query) => {
    try {
        
        const response = await client.getSelect(`detalles?q=${query}`);        
        if (response.status === 200 && response.data.code === 1) {
            return {
                vehiculos: response.data.object,               
                query: query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getClasificaRespuesta= async(query) => {
    try {
        
        const response = await client.getSelect(`detalles?q=${query}`);    
        if (response.status === 200 && response.data.code === 1) {
            return {
                clasificaRespuesta: response.data.object,               
                query: query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getMotivo= async(query) => {
    try {
        
        const response = await client.getSelect(`detalles?q=${query}`);        
        if (response.status === 200 && response.data.code === 1) {
            return {
                motivo: response.data.object,               
                query: query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getEstadoAccion= async(query) => {
    try {
        
        const response = await client.get(`caso/recobro/antec-respuesta?q=${query}`);    
        if (response.status === 200 && response.data.code === 1) {
            return {
                estadoAccion: response.data.object,               
                query: query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getSeguros= async(query) => {
    try {
        
        const response = await client.getSelect(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                seguros: response.data.object,               
                query: query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getcompanias= async(query) => {
    try {
        
        const response = await client.getSelect(`companias?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                companias: response.data.object,               
                query: query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDetalles= async(query) => {
    try {
        
        const response = await client.getSelect(`detalles?q=${query}`);        
        if (response.status === 200 && response.data.code === 1) {
            return {
                detalles: response.data.object,               
                query: query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getHitosCaso= async(query) => {
    try {
        
        const response = await client.getSelect(`consulta/detalle/hitos?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                hitosCasoR: response.data.object,               
               
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getConfiguracionForm33 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form33: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const enviarCartaCobro= async(newClient) => {
    try {
        const response = await client.post('caso/recobro/prepara-carta',newClient)      
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaCarta: response.data};
        } else {
            return {respuestaCarta: response.data};
        }
        
    } catch(error){
        throw error;
        console.log(error)
    }
}

export const enviarRespuestaCobro = async(file) => {
    try {
        
        const response = await client.post('caso/recobro/respuesta', file);
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaRecobro: response.data};
        } else {
            return {respuestaRecobro: response.data};
        }

    } catch(error){
        throw error;
    }
}

export const getCoberturasVigentes = async(query) => {
    try {
        const response = await client.coberturasVigentes(`pretensiones/coberturas?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}